import { useCallback, useEffect } from 'react';
import { useURLFilterState } from '@client/hooks/useURLFilterState';
import { useTreatmentSearchEnrichedData } from './useTreatmentSearchEnrichedData';
import { TREATMENT_FIELD_TO_ENRICHED } from '@client/config/filterFieldMappings';

const TREATMENT_FILTERS = [
  'cultures',
  'cultural_practices',
  'treatment_types',
  'application_types',
  'intervention_periods',

  // Reseeding
  'reseeding_cultures',
  'reseeding_deadlines',

  //Extra filters Agronomic
  'enemies',
  'commercial_products',
  'active_substances',
  'pesticide_groups',
  'culture_stages',
  'organic_approval',
  'soil_types',
  'intercrop_cultures',

  // Application details
  'application_methods',
  'application_zones',
  'surfaces_to_treat',
  'techniques_or_application_places',

  'acute_toxicity',
  'long_term_effects',
  'fish_or_daphnia',
  'birds',
  'bees',
  'persistence',
  'leaching_potential',
];

export const useTreatmentFilters = () => {
  const urlState = useURLFilterState(TREATMENT_FILTERS, {
    defaultPagination: { page: 1, size: 100 },
    throttleMs: 300,
    clearOnDefault: true,
  });

  const {
    enrichedData,
    isLoadingLabels,
    resetEnrichedData,
    updateEnrichedField,
    getLabelsForField,
    buildSelectionLabels,
  } = useTreatmentSearchEnrichedData(urlState.filters);

  // Sync enriched labels into the filter labels store for display
  useEffect(() => {
    if (isLoadingLabels || !enrichedData) return;

    Object.entries(TREATMENT_FIELD_TO_ENRICHED).forEach(([filterKey, enrichedKey]) => {
      const items = enrichedData[enrichedKey];
      if (items && items.length > 0) {
        items.forEach((item) => {
          if (item.value && item.label) {
            urlState.setFilterLabel(filterKey, item.value, item.label);
          }
        });
      }
    });
  }, [enrichedData, isLoadingLabels, urlState.setFilterLabel]);

  // Wrap resetFilters to also reset enriched data
  const resetFilters = useCallback(() => {
    urlState.resetFilters();
    resetEnrichedData();
  }, [urlState.resetFilters, resetEnrichedData]);

  return {
    ...urlState,
    resetFilters,
    enrichedData,
    isLoadingLabels,
    updateEnrichedField,
    getLabelsForField,
    buildSelectionLabels,
  };
};
